module.exports = __webpack_public_path__ + "img/carbide-drill-bit-mobile.a2f0fc2b.jpg";